import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {
  getEventByEventId,
  publishEvent,
  saveDraftEvent,
  updateEvent,
} from "apis/EventServiceApi";
import { linkEvents } from "apis/ProjectServiceApi";
import { searchDocuments } from "apis/UserServiceApi";
import CausesSelector from "components/forms/CausesSelector/CausesSelector";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PostsSelector from "components/forms/PostsSelector";
import { CreateEventData, IEventData } from "types";
import {
  countryData,
  statesData,
  timeZones,
} from "../CreateOrganization/DropDownData/DropDownData";
import {
  BackButton,
  BackStageButton,
  Circle,
  CollaborationContainer,
  ContinueButton,
  CreateEventContainer,
  CreateEventContent,
  CreateEventFooter,
  CreateEventTitle,
  DateInput,
  Dropdown,
  EventDetailsContainer,
  EventGoalContainer,
  EventImageContainerUrl,
  EventNameContainer,
  ExamineAndVerify,
  FieldContainer,
  FieldTitle,
  FieldTitle2,
  FormRow,
  InputContainer,
  LocationCard,
  LocationContainer,
  LocationFormRow,
  LocationScrollContainer,
  PrivacyContainer,
  PrivacyOption,
  ProgressContainer,
  ProgressLine,
  Slider,
  Stage,
  StageContainer,
  StageTitle,
  SwitchContainer,
  SwitchInput,
  Text,
  Text2,
  TimeZones,
} from "./CreateEvent.styles";
import UserInviteList from "./UserInviteList";

interface CreateEventProps {
  onClick: () => void;
  editingEvent?: IEventData | null;
  onRefresh?: () => void;
}

const stages = [
  { id: 1, title: "Event Information" },
  { id: 2, title: "Event Logistics" },
  { id: 3, title: "Invite Attendees" },
];

const CreateEvent = () => {
  const { eventId, projectId } = useParams();
  const [eventToEdit, setEventToEdit] = useState<IEventData | null>(null);
  const [currentStage, setCurrentStage] = useState(1);
  const [draftId, setDraftId] = useState<number | null>(null);
  const [isCollaborating, setIsCollaborating] = useState(false);
  const [searchTermCollab, setSearchTermCollab] = useState("");
  const [searchTermAttendees, setSearchTermAttendees] = useState("");
  const [attendees, setAttendees] = useState<Attendee[]>([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState<CreateEventData>({
    activity_title: "",
    start_date_time: "",
    end_date_time: "",
    Event_image: "",
    activity_description: "",
    activity_goal: "",
    Country: "",
    City: "",
    State: "",
    Postcode: "",
    Details: "Default",
    GoogleUrl: "",
    influencerIds: [],
    brandIds: [],
    volunteerIds: [],
    nonProfitIds: [],
    inviteIds: [],
    causeIds: [],
    postIds: [],
    is_private: 0,
  });

  const [eventDate, setEventDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOption, setSelectedOption] = useState("public");
  const [selectedLocation, setSelectedLocation] = useState<string[]>([]);

  const locationType = ["In Person", "Online Event", "TBA"];

  useEffect(() => {
    if (eventId) {
      getEventByEventId({ id: Number(eventId) }).then((response) => {
        setEventToEdit(response);
        console.log(response);
      });
    }
  }, [eventId]);

  useEffect(() => {
    const fetchAttendees = async () => {
      try {
        const response = await searchDocuments("volunteer");
        setAttendees(response.data);
      } catch (error) {
        console.error("Error fetching attendees:", error);
      }
    };
    fetchAttendees();
  }, []);

  useEffect(() => {
    if (eventToEdit) {
      const p = eventToEdit?.places?.[0];
      const event_image = eventToEdit?.visuals?.[0]?.image_url || "";
      const causeIds = eventToEdit?.pursuits?.map((c) => c.id) || [];
      setFormData((prev) => ({
        ...prev,
        id: eventToEdit?.activity.id,
        activity_title: eventToEdit?.activity.activity_title || "",
        start_date_time: eventToEdit?.activity.start_date_time || "",
        end_date_time: eventToEdit?.activity.end_date_time || "",
        Event_image: event_image,
        activity_description: eventToEdit?.activity.activity_description || "",
        activity_goal: eventToEdit?.activity.activity_goal || "",
        Country: p?.place_country || "",
        City: p?.place_city || "",
        State: p?.place_state || "",
        Postcode: p?.place_postcode || "",
        Details: p?.place_details || "Default",
        GoogleUrl: "",
        influencerIds: [],
        brandIds: [],
        volunteerIds: [],
        nonProfitIds: [],
        inviteIds: [],
        causeIds: causeIds,
        postIds: formData.postIds,
        is_private: eventToEdit?.activity.is_private ?? 0,
      }));
      const splittedStart = eventToEdit?.activity.start_date_time.split(" ");
      if (splittedStart?.length === 2) {
        setEventDate(splittedStart[0]);
        setStartTime(splittedStart[1].slice(0, 5));
      }
      const splittedEnd = eventToEdit?.activity.end_date_time.split(" ");
      if (splittedEnd?.length === 2) {
        setEndDate(splittedEnd[0]);
        setEndTime(splittedEnd[1].slice(0, 5));
      }
      setSelectedItems(causeIds.map((id) => id.toString()));
      const influencerIds: number[] = [];
      const brandIds: number[] = [];
      const volunteerIds: number[] = [];
      const inviteIds: number[] = [];
      const nonProfitIds: number[] = [];
      let foundCollaborator = false;
      eventToEdit?.users?.forEach((u) => {
        const userId = u.user_id;
        const { template_type, part_type } = u;
        if (part_type === "Collaborator") {
          foundCollaborator = true;
          switch (template_type) {
            case "influencer":
              influencerIds.push(userId);
              break;
            case "brand":
              brandIds.push(userId);
              break;
            case "volunteer":
              volunteerIds.push(userId);
              break;
            case "nonprofit":
              nonProfitIds.push(userId);
              break;
            default:
              console.warn("Tipo de colaborador no reconocido:", u);
          }
        } else if (part_type === "Attendee") {
          inviteIds.push(userId);
        } else {
          console.warn("Tipo de asistente no reconocido:");
        }
      });
      if (foundCollaborator) {
        setIsCollaborating(true);
      }
      setFormData((prev) => ({
        ...prev,
        influencerIds,
        brandIds,
        volunteerIds,
        inviteIds,
        nonProfitIds,
      }));
    }
  }, [eventToEdit]);

  const handleInputChange = (
    field: keyof CreateEventData,
    value: string | number[]
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDateTimeChange = (type: string, value: string) => {
    switch (type) {
      case "eventDate":
        setEventDate(value);
        if (startTime) {
          handleInputChange(
            "start_date_time",
            formatDateTime(value, startTime)
          );
        }
        break;
      case "startTime":
        setStartTime(value);
        if (eventDate) {
          handleInputChange(
            "start_date_time",
            formatDateTime(eventDate, value)
          );
        }
        break;
      case "endDate":
        setEndDate(value);
        if (endTime) {
          handleInputChange("end_date_time", formatDateTime(value, endTime));
        }
        break;
      case "endTime":
        setEndTime(value);
        if (endDate) {
          handleInputChange("end_date_time", formatDateTime(endDate, value));
        }
        break;
      default:
        break;
    }
  };

  const formatDateTime = (date: string, time: string) => {
    if (!date || !time) return "";
    const [hours, minutes] = time.split(":");
    const formattedDate = new Date(date);
    formattedDate.setHours(parseInt(hours, 10));
    formattedDate.setMinutes(parseInt(minutes, 10));

    const year = formattedDate.getFullYear();
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
    const day = String(formattedDate.getDate()).padStart(2, "0");
    const hour = String(formattedDate.getHours()).padStart(2, "0");
    const minute = String(formattedDate.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hour}:${minute}:00`;
  };

  const handleSaveDraft = async () => {
    setIsSubmitting(true);
    try {
      const draftData = {
        ...formData,
        end_date_time: formData.end_date_time || "",
        causeIds: formData.causeIds,
        postIds: formData.postIds,
      };
      const cleanFormData: CreateEventData = Object.fromEntries(
        Object.entries(draftData).filter(
          ([_, val]) => val !== null && val !== undefined
        )
      ) as unknown as CreateEventData;

      if (eventToEdit) {
        cleanFormData.id = eventToEdit.activity.id;

        const response = await updateEvent(cleanFormData);
        setDraftId(response.id);

        toast.success("Event updated (draft) successfully!");
      } else {
        const response = await saveDraftEvent(cleanFormData);
        setDraftId(response.id);

        toast.success("Draft saved successfully!");
      }
      handleBackToEvents();
    } catch (error: any) {
      console.error("Error saving draft:", error);
      toast.error("Failed to save draft");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFinish = async () => {
    setIsSubmitting(true);
    try {
      if (
        !formData.Event_image ||
        !formData.activity_title ||
        !formData.start_date_time ||
        !formData.activity_description
      ) {
        toast.error(
          "Please fill in all required fields (Title, Start Time, Description, Image URL)"
        );
        return;
      }
      const publishData = {
        ...formData,
        end_date_time: formData.end_date_time || "",
        causeIds: formData.causeIds,
        postIds: formData.postIds,
      };
      if (draftId) {
        publishData.id = draftId;
      }
      await publishEvent(publishData).then(async (r) => {
        if (projectId) {
          await linkEvents({ projectId: Number(projectId), eventIds: [r.id] });
        }
      });
      toast.success("Event published successfully!");
      handleBackToEvents();
    } catch (error: any) {
      console.error("Error publishing event:", error);
      toast.error("Failed to publish event");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNextStage = async () => {
    if (currentStage === stages.length) {
      if (
        !formData.activity_title ||
        !formData.Event_image ||
        !formData.activity_description ||
        !formData.activity_goal ||
        selectedItems.length === 0
      ) {
        alert("Please fill in all required fields in Event Information");
        setCurrentStage(1);
        return;
      }
      if (!formData.start_date_time || !formData.end_date_time) {
        alert("Please fill in all required date and time fields");
        setCurrentStage(2);
        return;
      }
      if (
        !formData.Country ||
        !formData.State ||
        !formData.City ||
        !formData.Postcode
      ) {
        alert("Please fill in all required location fields");
        setCurrentStage(2);
        return;
      }
      try {
        const eventData: CreateEventData = {
          ...formData,
          start_date_time: formatDateTime(eventDate, startTime),
          end_date_time: formatDateTime(endDate, endTime) || "",
          causeIds: selectedItems.map(Number).filter((id) => !isNaN(id)),
          is_private: selectedOption === "private" ? 1 : 0,
          postIds: formData.postIds,
        };
        await publishEvent(eventData);
        toast.success("Event published successfully!");
      } catch (error) {
        console.error("Failed to create event", error);
        toast.error("Failed to create event");
      }
    } else {
      setCurrentStage((prev) => prev + 1);
    }
  };

  const handlePreviousStage = () => {
    if (currentStage > 1) {
      setCurrentStage((prev) => prev - 1);
    }
  };

  const handleBackToEvents = () => {
    navigate(-1);
  };

  const handleSwitchChange = () => {
    setIsCollaborating(!isCollaborating);
  };

  const handleLocationClick = (item: string) => {
    if (selectedLocation.includes(item)) {
      setSelectedLocation(selectedLocation.filter((i) => i !== item));
    } else {
      setSelectedLocation([item]);
    }
  };

  const toggleInviteAttendee = (attendee: Attendee) => {
    const { id } = attendee;
    if (formData.inviteIds.includes(id)) {
      setFormData((prev) => ({
        ...prev,
        inviteIds: prev.inviteIds.filter((v) => v !== id),
      }));
    } else {
      removeFromCollaborators(attendee);
      setFormData((prev) => ({
        ...prev,
        inviteIds: [...prev.inviteIds, id],
      }));
    }
  };

  const isInvitedAttendee = (attendee: Attendee) => {
    return formData.inviteIds.includes(attendee.id);
  };

  const toggleCollaborator = (attendee: Attendee) => {
    const { id, myself_type, organization_type } = attendee;
    if (formData.inviteIds.includes(id)) {
      setFormData((prev) => ({
        ...prev,
        inviteIds: prev.inviteIds.filter((v) => v !== id),
      }));
    }
    if (isInAnyCollaboratorList(id)) {
      removeFromCollaborators(attendee);
    } else {
      if (myself_type === "influencer") {
        setFormData((prev) => ({
          ...prev,
          influencerIds: [...prev.influencerIds, id],
        }));
      } else if (myself_type === "volunteer") {
        setFormData((prev) => ({
          ...prev,
          volunteerIds: [...prev.volunteerIds, id],
        }));
      } else if (organization_type === "brand") {
        setFormData((prev) => ({
          ...prev,
          brandIds: [...prev.brandIds, id],
        }));
      } else if (organization_type === "nonprofit") {
        setFormData((prev) => ({
          ...prev,
          nonProfitIds: [...prev.nonProfitIds, id],
        }));
      } else {
        console.warn("Unrecognized contributor type.", attendee);
      }
    }
  };

  const isInAnyCollaboratorList = (id: number) => {
    const { influencerIds, brandIds, volunteerIds, nonProfitIds } = formData;
    return (
      influencerIds.includes(id) ||
      brandIds.includes(id) ||
      volunteerIds.includes(id) ||
      nonProfitIds.includes(id)
    );
  };

  const isInvitedCollaborator = (attendee: Attendee) => {
    return isInAnyCollaboratorList(attendee.id);
  };

  const removeFromCollaborators = (attendee: Attendee) => {
    const { id } = attendee;
    setFormData((prev) => ({
      ...prev,
      influencerIds: prev.influencerIds.filter((x) => x !== id),
      brandIds: prev.brandIds.filter((x) => x !== id),
      volunteerIds: prev.volunteerIds.filter((x) => x !== id),
      nonProfitIds: prev.nonProfitIds.filter((x) => x !== id),
    }));
  };

  const generateTimeOptions = () => {
    const times = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 30) {
        const hour = String(hours).padStart(2, "0");
        const minute = String(minutes).padStart(2, "0");
        times.push(`${hour}:${minute}`);
      }
    }
    return times;
  };
  const timeOptions = generateTimeOptions();

  const collaboratorIDs = [
    ...formData.influencerIds,
    ...formData.brandIds,
    ...formData.volunteerIds,
    ...formData.nonProfitIds,
  ];

  return (
    <CreateEventContainer>
      <ToastContainer />
      <CreateEventContent>
        <BackButton onClick={handleBackToEvents}>
          <KeyboardArrowLeftIcon style={{ marginLeft: "3px" }} />
          Back
        </BackButton>
        <CreateEventTitle>
          {eventId ? "Edit Event" : "Create an Event"}
        </CreateEventTitle>
        <Text>
          Use to create an event to solve social issues. To get started, follow
          the examine & verify requirements "Create Event" and enter your event
          details.
        </Text>
        <ExamineAndVerify>Examine & Verify</ExamineAndVerify>
        <Text2>
          • Contradictory content in the event information will lead to the
          failure of the review.
        </Text2>
        <Text2>
          • If there is false or ambiguous content in the event information, the
          review will be rejected.
        </Text2>
        <Text2>
          • If the description of the event does not match the qualifications
          for participation, the review will be rejected.
        </Text2>

        <ProgressContainer>
          <ProgressLine />
          {stages.map((stage) => (
            <Stage
              key={stage.id}
              className={currentStage === stage.id ? "active" : ""}
            >
              <Circle className={currentStage === stage.id ? "active" : ""}>
                {stage.id}
              </Circle>
              <p>{stage.title}</p>
            </Stage>
          ))}
        </ProgressContainer>

        {/* -------------- STAGE 1 ---------------- */}
        {currentStage === 1 && (
          <StageContainer>
            <StageTitle>1. Event Information</StageTitle>
            <FieldTitle>* Indicates a required field</FieldTitle>

            <FieldTitle>Event Image Url *</FieldTitle>
            <EventImageContainerUrl>
              <input
                value={formData.Event_image || ""}
                onChange={(e) =>
                  handleInputChange("Event_image", e.target.value)
                }
                placeholder="Event Image URL"
              />
            </EventImageContainerUrl>

            <FieldTitle>Event Name *</FieldTitle>
            <EventNameContainer>
              <input
                value={formData.activity_title || ""}
                onChange={(e) =>
                  handleInputChange("activity_title", e.target.value)
                }
                placeholder="Event Name"
              />
            </EventNameContainer>

            <FieldTitle>Event Details *</FieldTitle>
            <EventDetailsContainer>
              <textarea
                value={formData.activity_description}
                onChange={(e) =>
                  handleInputChange("activity_description", e.target.value)
                }
                placeholder="Event Details"
              />
            </EventDetailsContainer>

            <FieldTitle>Event Goal *</FieldTitle>
            <EventGoalContainer>
              <input
                value={formData.activity_goal || ""}
                onChange={(e) =>
                  handleInputChange("activity_goal", e.target.value)
                }
                placeholder="Event Goal"
              />
            </EventGoalContainer>

            <FieldTitle>Select Causes *</FieldTitle>
            <CausesSelector
              selectedCauses={formData.causeIds}
              setSelectedCauses={(ids) => handleInputChange("causeIds", ids)}
              border={{
                borderColor: "#8692a6",
                borderStyle: "solid",
                borderWidth: "0.0625rem",
              }}
              maxWidth="50.875rem"
            />
            <FieldTitle>Select Related Posts</FieldTitle>
            <PostsSelector
              selectedPostIds={formData.postIds}
              setSelectedPostIds={(ids) => handleInputChange("postIds", ids)}
              border={{
                borderColor: "#8692a6",
                borderStyle: "solid",
                borderWidth: "0.0625rem",
              }}
              maxWidth="50.875rem"
            />
          </StageContainer>
        )}

        {/* -------------- STAGE 2 ---------------- */}
        {currentStage === 2 && (
          <StageContainer>
            <StageTitle>2. Event Logistics</StageTitle>
            <FieldTitle>* Indicates a required field</FieldTitle>
            <FieldTitle2>Date & Time</FieldTitle2>

            <FieldTitle>Timezone *</FieldTitle>
            <TimeZones>
              {timeZones.map((zone, index) => (
                <option key={index} value={zone}>
                  {zone}
                </option>
              ))}
            </TimeZones>

            <FormRow>
              <FieldContainer>
                <FieldTitle>Event starts *</FieldTitle>
                <DateInput
                  type="date"
                  value={eventDate}
                  onChange={(e) =>
                    handleDateTimeChange("eventDate", e.target.value)
                  }
                />
              </FieldContainer>
              <FieldContainer>
                <FieldTitle>Start time *</FieldTitle>
                <Dropdown
                  value={startTime}
                  onChange={(e) =>
                    handleDateTimeChange("startTime", e.target.value)
                  }
                >
                  <option value="">Select Time</option>
                  {timeOptions.map((time, index) => (
                    <option key={index} value={time}>
                      {time}
                    </option>
                  ))}
                </Dropdown>
              </FieldContainer>
            </FormRow>
            <FormRow>
              <FieldContainer>
                <FieldTitle>Event ends *</FieldTitle>
                <DateInput
                  type="date"
                  value={endDate}
                  onChange={(e) =>
                    handleDateTimeChange("endDate", e.target.value)
                  }
                />
              </FieldContainer>
              <FieldContainer>
                <FieldTitle>Finish time *</FieldTitle>
                <Dropdown
                  value={endTime}
                  onChange={(e) =>
                    handleDateTimeChange("endTime", e.target.value)
                  }
                >
                  <option value="">Select Time</option>
                  {timeOptions.map((time, index) => (
                    <option key={index} value={time}>
                      {time}
                    </option>
                  ))}
                </Dropdown>
              </FieldContainer>
            </FormRow>

            <LocationContainer>
              <FieldTitle>Event location type *</FieldTitle>
              <LocationScrollContainer>
                {locationType.map((type, index) => (
                  <LocationCard
                    key={index}
                    selected={selectedLocation.includes(type)}
                    onClick={() => handleLocationClick(type)}
                  >
                    {type}
                  </LocationCard>
                ))}
              </LocationScrollContainer>
            </LocationContainer>

            <LocationFormRow>
              <FieldContainer>
                <FieldTitle>Country *</FieldTitle>
                <Dropdown
                  value={formData.Country}
                  onChange={(e) => handleInputChange("Country", e.target.value)}
                >
                  <option value="">Select Country</option>
                  {countryData.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </Dropdown>
              </FieldContainer>
              <FieldContainer>
                <FieldTitle>State *</FieldTitle>
                {formData.Country === "United States" ? (
                  <Dropdown
                    value={formData.State}
                    onChange={(e) => handleInputChange("State", e.target.value)}
                  >
                    <option value="">Select State</option>
                    {statesData.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </Dropdown>
                ) : (
                  <InputContainer>
                    <input
                      value={formData.State || ""}
                      onChange={(e) =>
                        handleInputChange("State", e.target.value)
                      }
                      placeholder="Enter State/Province"
                    />
                  </InputContainer>
                )}
              </FieldContainer>
              <FieldContainer>
                <FieldTitle>City *</FieldTitle>
                <InputContainer>
                  <input
                    value={formData.City || ""}
                    onChange={(e) => handleInputChange("City", e.target.value)}
                    placeholder="Enter City"
                  />
                </InputContainer>
              </FieldContainer>
              <FieldContainer>
                <FieldTitle>Postcode *</FieldTitle>
                <InputContainer>
                  <input
                    value={formData.Postcode || ""}
                    onChange={(e) =>
                      handleInputChange("Postcode", e.target.value)
                    }
                    placeholder="Enter Postcode"
                  />
                </InputContainer>
              </FieldContainer>
            </LocationFormRow>

            <FieldTitle2>Collaboration</FieldTitle2>
            <CollaborationContainer>
              <FieldTitle>Do you want to collaborate with someone?</FieldTitle>
              <SwitchContainer>
                <SwitchInput
                  type="checkbox"
                  checked={isCollaborating}
                  onChange={handleSwitchChange}
                />
                <Slider />
              </SwitchContainer>
            </CollaborationContainer>

            {isCollaborating && (
              <UserInviteList
                title="Invite Collaborators"
                attendees={attendees}
                searchTerm={searchTermCollab}
                setSearchTerm={setSearchTermCollab}
                isInvitedFn={isInvitedCollaborator}
                toggleInviteFn={toggleCollaborator}
                filterFn={() => true}
                excludeIds={formData.inviteIds}
              />
            )}

            <FieldTitle2>Privacy</FieldTitle2>
            <PrivacyContainer>
              <PrivacyOption>
                <input
                  type="radio"
                  name="privacy"
                  value="public"
                  checked={selectedOption === "public"}
                  onChange={() => setSelectedOption("public")}
                />
                <div className="radio-circle"></div>
                <div>
                  <div>
                    <strong>Public</strong>
                    <span className="lock-icon" role="img" aria-label="unlock">
                      🔓
                    </span>
                  </div>
                  <div className="description">
                    Anyone can view and attend this event
                  </div>
                </div>
              </PrivacyOption>
              <PrivacyOption>
                <input
                  type="radio"
                  name="privacy"
                  value="private"
                  checked={selectedOption === "private"}
                  onChange={() => setSelectedOption("private")}
                />
                <div className="radio-circle"></div>
                <div>
                  <div>
                    <strong>Private</strong>{" "}
                    <span className="lock-icon" role="img" aria-label="lock">
                      🔒
                    </span>
                  </div>
                  <div className="description">
                    Only invitees can view and attend this event
                  </div>
                </div>
              </PrivacyOption>
            </PrivacyContainer>
          </StageContainer>
        )}

        {/* -------------- STAGE 3 ---------------- */}
        {currentStage === 3 && (
          <StageContainer>
            <UserInviteList
              title="Invite Attendees"
              attendees={attendees}
              searchTerm={searchTermAttendees}
              setSearchTerm={setSearchTermAttendees}
              isInvitedFn={isInvitedAttendee}
              toggleInviteFn={toggleInviteAttendee}
              filterFn={(user) =>
                user.user_type === "myself" && user.myself_type === "volunteer"
              }
              excludeIds={collaboratorIDs}
            />
          </StageContainer>
        )}
      </CreateEventContent>

      <CreateEventFooter>
        <BackStageButton
          onClick={handlePreviousStage}
          style={{ visibility: currentStage > 1 ? "visible" : "hidden" }}
        >
          Back
        </BackStageButton>
        <div style={{ display: "flex", gap: "10px" }}>
          {currentStage === stages.length && (
            <ContinueButton
              onClick={handleSaveDraft}
              disabled={isSubmitting}
              style={{ opacity: isSubmitting ? 0.5 : 1 }}
            >
              Save Draft
            </ContinueButton>
          )}
          <ContinueButton
            onClick={
              currentStage < stages.length ? handleNextStage : handleFinish
            }
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.5 : 1 }}
          >
            {currentStage < stages.length ? "Continue" : "Finish"}
          </ContinueButton>
        </div>
      </CreateEventFooter>
    </CreateEventContainer>
  );
};

export default CreateEvent;
